import { PostgrestError } from '@supabase/supabase-js'

export const isSupabasePostgrestError = (err: unknown): err is PostgrestError => {
  const errorProps = ['code', 'message', 'hint', 'details']

  return !!err && typeof err === 'object' && errorProps.every((prop) => prop in err)
}
